<template>
  <NewStudioRightPanel />
</template>
